// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/type.js';

import { paths } from '../generated/type';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('type', Original, paths);
